<script>
  import { TimeSelect } from 'element-ui'
  export default {
    name:'ElTimeSelect',
    extends:TimeSelect
  }
</script>
